import { createI18n } from "vue-i18n";
import Axios from 'axios';
import { EventTypes } from './delivery-address-events';

// Create VueI18n instance with options
const i18n = createI18n({
    locale: 'nb', // set locale
    silentTranslationWarn: true, // do not warn about missing texts
    allowComposition: true,
    interpolation: {
        prefix: '{',
        suffix: '}'
    }

});

var resourceObjects = [
    'DeliveryAddress',
    'Vuelidate',
    'VueAdmin',
    'LOGINOUT',
    'CUSTOMER_REGISTRATION',
    'CHECKOUT'
];

Axios.post('/api/Language/GetResourcesForObjects',
    resourceObjects
)
    .then((response) => {
        i18n.global.setLocaleMessage('nb', response.data);
        PubSub.publish(EventTypes.TEXTS_LOADED);
    });

export default i18n;